import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const WarehouseSchema_ = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  address: z.object({
    _id: zExt.objectId(),
    city: z.string().nullish(),
    zip: z.string().nullish(),
    country: z.string().nullish(),
  }),
  team: zExt.objectId(),
  externalId: z.string().optional(),
  externalSource: z.string().optional(),
});

export const WarehouseSchema: z.ZodType<Warehouse> = WarehouseSchema_;
export type Warehouse = z.infer<typeof WarehouseSchema_>;

export const InventoryLevelSchema = z.object({
  warehouse: zExt.objectId(),
  quantity: z.number().min(0),
  committed: z.number().min(0).default(0),
});
